import { useKeycloak } from "@react-keycloak/web";
import React, { useEffect, useState } from "react";
import { Modal, ModalBody, ModalHeader, Row } from "reactstrap";
import { default as Swal, default as SweetAlert } from "sweetalert2";
import { CourseDto } from "../../../../models/courseDto";
import hasRoles from "../../../../security/hasRoles";
import { useHttpClient } from "../../../../security/hooks/axiosProvider";
import FileViewer from "../../../../shared/file-viewer/FileViewer";
import ButtonComponent from "../components/buttonComponent";
import styles from "./course.module.scss";
import ReactPlayer from "react-player/lazy";
import { translate } from "react-switch-lang";

const CourseSuportModal: React.FC<{ course: CourseDto; openModalViewer: boolean; handleClickOpenModalViewer: any; isCourseFinished: boolean;t: (key: string) => string }> = ({
  course,
  openModalViewer,
  handleClickOpenModalViewer,
  isCourseFinished,
  t
}) => {
  const keycloak = useKeycloak().keycloak;
  const hasRoleAdmin = hasRoles(["ROLE_ELEARNING_ADMIN"], keycloak);
  const httpClient = useHttpClient(keycloak.authenticated);
  const [courseFinished, setCoursFinished] = useState(false);

  useEffect(() => {
    if (course && course.id) {
      httpClient.current.get(`/course/isCourseFinished/${course?.id}`).then(res => {
        setCoursFinished(res.data);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openModalViewer, isCourseFinished]);

  const finishCourse = () => {
    SweetAlert.fire({
      title: t("finish_course_quation"),
      cancelButtonText: t("cancel"),
      confirmButtonText: t("finish"),
      confirmButtonColor: "#FF0000",
      reverseButtons: true,
      showCancelButton: true,
      icon: "warning",
    }).then(result => {
      if (result.isConfirmed) {
        httpClient.current.post(`/course/AddCourse/${course.id}`).then(res => {
          handleClickOpenModalViewer(course);
        });
        Swal.fire(t("course_completed_message"), "", "success");
      }
    });
  };

  return (
    <Modal backdrop={"static"} isOpen={openModalViewer} centered={true} className={styles["support_modal"]}>
      <ModalHeader toggle={handleClickOpenModalViewer}>{"Le support du cours"}</ModalHeader>
      <ModalBody>
        {course?.courseType === "PDF" && <FileViewer src={course?.supportUrl} width={"100%"} height={(window.innerHeight*0.83)+"px"} />}
        {course?.courseType === "VIDEO" && <ReactPlayer url={course?.supportUrl+"/download"} width={"100%"} height={window.outerWidth > 600 ? "580px" : "420px"} controls={true} />}
        {!hasRoleAdmin && !courseFinished && (
          <Row className={styles["finish_button_row"]}>
            <ButtonComponent onClick={finishCourse} disable={false} buttonType={"submit"} buttonText={t("finished")} save={true} />
          </Row>
        )}
      </ModalBody>
    </Modal>
  );
};

export default translate(CourseSuportModal);
